import { Divider } from '@mantine/core';

export default Divider.extend({
  defaultProps: {
    color: 'gray.2',
  },
});
